import "../../assets/index23.css";
import { jsxs as u, jsx as l } from "react/jsx-runtime";
import { I as i } from "../../chunks/index.3a885b6a.js";
import { m as b } from "../../chunks/make-refs.cb0b9b76.js";
import { c as y } from "../../chunks/index.80e735c1.js";
import { forwardRef as p } from "react";
const x = "_buttonQty_dm8sx_1", f = "_quantity_dm8sx_33", Q = "_label_dm8sx_40", g = "_largeQty_dm8sx_72", h = "_selected_dm8sx_79", j = "_large_dm8sx_72", I = "_small_dm8sx_146", t = {
  buttonQty: x,
  quantity: f,
  label: Q,
  largeQty: g,
  selected: h,
  large: j,
  small: I
}, C = p(
  ({
    className: m,
    label: e,
    quantity: s = 0,
    size: o = "medium",
    variant: n = "add",
    ...a
  }, r) => {
    const { $el: c } = b(r, ["$el"]), d = n === "add" ? "24/symbol/plus-bold" : "24/symbol/minus-bold", _ = y(t.buttonQty, m, {
      [t[o]]: o !== "medium",
      [t.selected]: s > 0,
      [t.label]: !!e,
      [t.largeQty]: s > 999
    });
    return /* @__PURE__ */ u("button", { className: _, ref: c, type: "button", ...a, children: [
      s > 0 && /* @__PURE__ */ l("span", { "aria-hidden": !0, className: t.quantity, children: s }),
      s === 0 && !e ? /* @__PURE__ */ l(i, { icon: d }) : null,
      e
    ] });
  }
);
export {
  C as ButtonQuantity
};
//# sourceMappingURL=index.js.map
